<template>
  <MobileButton v-bind="$attrs"
                btn-style="icon"
                color="grey.lighten-3"
                v-on ="$listeners">
    <svg v-svg
         :symbol="symbol"
         :size="iconSize"
         :style="iconStyle"
    />
  </MobileButton>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import MobileButton from '@/apps/mobile/components/MobileButton';

/**
 * Mobile icons buttons.
 */
@Component({
  props: {
    /**
     * Icon symbol.
     */
    symbol: {
      type:     String,
      default:  null,
      required: true,
    },
    /**
     * Icon size.
     */
    iconSize: {
      type:     String,
      default:  null,
      required: false,
    },
    /**
     * Icon fill color.
     */
    iconFill: {
      type:     String,
      default:  null,
      required: false,
    },
  },
  components: {
    MobileButton,
  },
})
export default class MobileIconButton extends Vue {
  get iconStyle() {
    return { fill: this.iconFill };
  }
}
</script>



// WEBPACK FOOTER //
// src/apps/mobile/components/MobileIconButton.vue